export default {
    links: {
        applyFormLink: window.raeEnv.flexiBffUrl,
        loginLink: window.raeEnv.loginUrl,
        documentsBaseUrl: window.raeEnv.documentsBaseUrl,
        documentUrl: window.raeEnv.documentsUrl,
        productPageUrl: window.raeEnv.productPageUrl
    }
};